export function clearSeconds(
  startDate: Date,
  endDate?: Date
): [startDate: Date, endDate: Date] {
  startDate.setSeconds(0);
  startDate.setMilliseconds(0);
  // if no end date, default to 30 minutes which is what we use
  // for new events in the UI
  if (!endDate) {
    const endDate = new Date(startDate);
    endDate.setMinutes(startDate.getMinutes() + 30);
    return [startDate, endDate];
  }

  endDate.setSeconds(0);
  endDate.setMilliseconds(0);

  return [startDate, endDate];
}
